import { render, staticRenderFns } from "./ModelCallHistory.vue?vue&type=template&id=c83530d6&"
import script from "./ModelCallHistory.vue?vue&type=script&lang=js&"
export * from "./ModelCallHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports